import { Flex, Stack, Title } from '@mantine/core'
import { IconChevronLeft } from '@tabler/icons-react'
import { useEffect, useMemo } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import UsersPage from 'src/pages/UsersPage/UsersPage'
import {
	buildLocationUsersPagePath,
	UserLocationSearchField,
} from 'src/utils/userLocationFilter'

const locationFields: UserLocationSearchField[] = ['country', 'province']

function LocationUsersPage() {
	const { name } = useParams<{ name: string }>()
	const { pathname } = useLocation()
	const navigate = useNavigate()
	const [searchParams, setSearchParams] = useSearchParams()
	const routeLocationType = pathname.split('/')[1]
	const field = locationFields.includes(routeLocationType as UserLocationSearchField)
		? routeLocationType as UserLocationSearchField
		: null
	const locationName = name || ''
	const expectedSearchParams = useMemo(() => {
		if (!field || !locationName) {
			return null
		}

		return new URLSearchParams(buildLocationUsersPagePath(field, locationName).split('?')[1])
	}, [field, locationName])
	const hasExpectedLocationFilter =
		searchParams.get('search_field') === field &&
		searchParams.get('search_key') === locationName

	useEffect(() => {
		if (expectedSearchParams && !hasExpectedLocationFilter) {
			setSearchParams(expectedSearchParams, { replace: true })
		}
	}, [expectedSearchParams, hasExpectedLocationFilter, setSearchParams])

	if (!field || !locationName || !hasExpectedLocationFilter) {
		return null
	}

	return (
		<Stack sx={{ width: '100%' }}>
			<Flex align="center" gap={4} sx={{ width: 'fit-content' }}>
				<IconChevronLeft
					style={{ cursor: 'pointer' }}
					onClick={() => navigate(`/?tab=${field}`)}
				/>
				<Title order={3}>Users in {locationName}</Title>
			</Flex>
			<UsersPage
				showManagementActions={false}
				showStatusFilter={false}
				showSearchFieldSelector={false}
				locationFilter={{ field, value: locationName }}
			/>
		</Stack>
	)
}

export default LocationUsersPage
